// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M7.380 4.056 C 6.939 4.121,6.582 4.212,6.240 4.345 C 4.229 5.127,2.923 7.117,3.014 9.260 C 3.046 10.005,3.188 10.593,3.502 11.273 C 3.842 12.008,3.823 11.987,8.041 16.214 L 11.987 20.169 15.680 16.494 C 17.711 14.474,19.505 12.669,19.667 12.485 C 20.860 11.125,21.265 9.472,20.821 7.780 C 20.688 7.272,20.591 7.031,20.355 6.620 C 20.097 6.168,19.865 5.866,19.489 5.490 C 18.661 4.663,17.714 4.203,16.520 4.050 C 16.095 3.996,15.942 3.993,15.500 4.034 C 14.257 4.148,13.264 4.605,12.361 5.481 L 11.989 5.842 11.585 5.450 C 10.836 4.724,10.041 4.305,9.027 4.101 C 8.587 4.013,7.816 3.992,7.380 4.056 " stroke="none" fillRule="evenodd"></path></>, 
'FavorisFillIcon', {
  viewBox: '0 0 24 24',
  height: '24',
  width: '24',
});